/// <reference types="vite/client" />
import axios from "axios";
export const parseAccessToken = (accessToken) => parseBase64Jwt(accessToken);
export const parseRefreshToken = (accessToken) => parseBase64Jwt(accessToken);
const parseBase64Jwt = (base64jwt) => {
    // The cookie is base64 encoded, and stores JSON
    if (!base64jwt) {
        return null;
    }
    const base64encodedPayload = base64jwt.split(".")[1];
    if (!base64encodedPayload) {
        return null;
    }
    const decoded = atob(base64encodedPayload);
    if (!decoded) {
        return null;
    }
    return JSON.parse(decoded);
};
const URL_SCHEME = import.meta.env ? import.meta.env["VITE_URL_SCHEME"] : process.env.REACT_APP_URL_SCHEME;
const SERVER_DOMAIN = import.meta.env ? import.meta.env["VITE_SERVER_DOMAIN"] : process.env.REACT_APP_SERVER_DOMAIN;
const appUrlRoot = `${URL_SCHEME}${SERVER_DOMAIN}`;
export const login = async ({ username, password, includeCookies }) => {
    return axios({
        method: "post",
        data: { username, password },
        withCredentials: true,
        url: `${appUrlRoot}/user/${includeCookies ? "web-login" : "login"}`,
    });
};
export const loginWithTeamworks = async ({ idToken, teamworksIdToken, teamworksDeviceSecret, teamworksOrgId, includeCookies, }) => {
    return axios({
        method: "post",
        data: { idToken, teamworksOrgId, teamworksIdToken, teamworksDeviceSecret },
        withCredentials: true,
        url: `${appUrlRoot}/user/login-with-teamworks/${includeCookies ? "web" : "mobile"}`,
    });
};
export const refresh = async ({ refreshToken, orgId }) => {
    let url;
    if (orgId) {
        url = `${appUrlRoot}/user/refresh/${orgId}`;
    }
    else {
        url = `${appUrlRoot}/user/refresh`;
    }
    return axios({
        method: "post",
        withCredentials: true,
        headers: refreshToken && {
            authorization: `Bearer ${refreshToken}`,
        },
        url,
    });
};
export const resetPassword = ({ password, resetPasswordToken }) => {
    return axios({
        method: "post",
        data: { password },
        withCredentials: true,
        url: `${appUrlRoot}/user/password/reset`,
        headers: {
            authorization: `Bearer ${resetPasswordToken}`,
        },
    });
};
export const activateOrgMembershipWithLogin = ({ username, password, activateToken, }) => {
    return axios({
        method: "post",
        data: { username, password },
        withCredentials: true,
        url: `${appUrlRoot}/org-membership/activate/org-membership-with-login`,
        headers: {
            authorization: `Bearer ${activateToken}`,
        },
    });
};
export const activateOrgMembershipWithRefreshToken = ({ activateToken, refreshToken, }) => {
    return axios({
        method: "post",
        data: { activateToken },
        withCredentials: true,
        url: `${appUrlRoot}/org-membership/activate/org-membership-with-refresh-token`,
        headers: refreshToken && {
            authorization: `Bearer ${refreshToken}`,
        },
    });
};
export const activateUserAndOrgMembership = ({ username, password, activateToken, }) => {
    return axios({
        method: "post",
        data: { username, password },
        withCredentials: true,
        url: `${appUrlRoot}/org-membership/activate/user-and-org-membership`,
        headers: {
            authorization: `Bearer ${activateToken}`,
        },
    });
};
export const sendPasswordResetLink = ({ username }) => {
    return axios({
        method: "post",
        data: { username },
        withCredentials: true,
        url: `${appUrlRoot}/user/password/send-reset-link`,
    });
};
export const sendEmailRecoveryLink = ({ email }) => {
    return axios({
        method: "post",
        data: { email },
        withCredentials: true,
        url: `${appUrlRoot}/user/username/send-email-recovery-link`,
    });
};
export const sendSmsRecoveryLink = ({ phoneNumber }) => {
    return axios({
        method: "post",
        data: { phoneNumber },
        withCredentials: true,
        url: `${appUrlRoot}/user/username/send-sms-recovery-link`,
    });
};
export const fetchUserOrgMemberships = async ({ refreshToken, }) => {
    return axios({
        method: "get",
        headers: refreshToken && {
            authorization: `Bearer ${refreshToken}`,
        },
        withCredentials: true,
        url: `${appUrlRoot}/user/memberships`,
    });
};
export const RESET_PASSWORD_CLIENT_URL = "/reset-password/:resetPasswordToken";
export const ACTIVATE_ORG_MEMBERSHIP_CLIENT_URL = "/activate/:activateToken";
export const TEAMWORKS_APP_LAUNCH_CLIENT_URL = "/teamworks-app-launch";
export const sendSelfServiceRequest = (data) => {
    return axios({
        method: "post",
        data,
        withCredentials: true,
        url: `${appUrlRoot}/org-membership/self-service-onboarding`,
    });
};
//# sourceMappingURL=tokens.js.map